var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfileCircle = function SvgProfileCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.734 17.316a2.93 2.93 0 0 0-2.736-2.917c-1.49-.104-2.386-.158-2.608-.158s-1.119.054-2.608.158a2.93 2.93 0 0 0-2.736 2.917v.58A9.1 9.1 0 0 0 10.39 19.6a8.7 8.7 0 0 0 5.344-1.816zM10.39 20.78a10.28 10.28 0 0 1-6.53-2.303v-1.161a4.114 4.114 0 0 1 3.839-4.094q2.296-.16 2.691-.16t2.691.16a4.114 4.114 0 0 1 3.84 4.094v1.026a9.9 9.9 0 0 1-6.531 2.438"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.39 20.78C4.652 20.78 0 16.127 0 10.39 0 4.65 4.652 0 10.39 0c5.737 0 10.39 4.65 10.39 10.39 0 5.738-4.653 10.39-10.39 10.39m0-1.196c5.082 0 9.2-4.117 9.2-9.194s-4.118-9.195-9.2-9.195c-5.083 0-9.201 4.117-9.201 9.195 0 5.077 4.118 9.194 9.2 9.194"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.39 12.468a4.156 4.156 0 1 1 0-8.312 4.156 4.156 0 0 1 0 8.312m0-1.193c1.64 0 2.97-1.327 2.97-2.963a2.966 2.966 0 0 0-2.97-2.963 2.966 2.966 0 0 0-2.969 2.963 2.966 2.966 0 0 0 2.97 2.963"
  })));
};
export default SvgProfileCircle;